module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fill-height"
  }, [_c('v-row', {
    staticClass: "mb-5",
    staticStyle: {
      "margin-bottom": "0px !important"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2",
      "lg": "2",
      "sm": "6"
    }
  }, [_c('v-combobox', {
    attrs: {
      "item-text": "title",
      "item-value": "value",
      "items": _vm.periods,
      "hide-details": ""
    },
    on: {
      "change": _vm.searchPeriodChanged
    },
    model: {
      value: (_vm.searchPeriod),
      callback: function($$v) {
        _vm.searchPeriod = $$v
      },
      expression: "searchPeriod"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2",
      "lg": "2",
      "sm": "6"
    }
  }, [_c('v-menu', {
    ref: "menu1",
    attrs: {
      "close-on-content-click": false,
      "return-value": _vm.startDate,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.startDate = $event
      },
      "update:return-value": function($event) {
        _vm.startDate = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": "From",
            "readonly": ""
          },
          model: {
            value: (_vm.startDate),
            callback: function($$v) {
              _vm.startDate = $$v
            },
            expression: "startDate"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.menu1),
      callback: function($$v) {
        _vm.menu1 = $$v
      },
      expression: "menu1"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "type": "month"
    },
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.menu1 = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.menu1.save(_vm.startDate)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2",
      "lg": "2",
      "sm": "6"
    }
  }, [_c('v-menu', {
    ref: "menu2",
    attrs: {
      "close-on-content-click": false,
      "return-value": _vm.endDate,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.endDate = $event
      },
      "update:return-value": function($event) {
        _vm.endDate = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": "To",
            "readonly": ""
          },
          model: {
            value: (_vm.endDate),
            callback: function($$v) {
              _vm.endDate = $$v
            },
            expression: "endDate"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.menu2),
      callback: function($$v) {
        _vm.menu2 = $$v
      },
      expression: "menu2"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "type": "month"
    },
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.menu2 = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.menu2.save(_vm.endDate)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2",
      "lg": "2",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Filter campaign",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "align": "right"
    }
  }, [_c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "small": "",
      "outlined": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.fetchReports
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "small": "",
      "outlined": "",
      "fab": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.fetchReports
    }
  }, [_c('v-icon', [_vm._v("mdi-refresh")])], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "search": _vm.search,
      "items": _vm.stats
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(ref) {
        var items = ref.items;

        return [_c('tbody', [_c('tr', {
          staticClass: "tr-summary"
        }, _vm._l((_vm.headers), function(header, index) {
          return _c('td', {
            key: index,
            staticClass: "caption text-xs-center",
            attrs: {
              "align": "center"
            }
          }, [(header.value === 'campaignName') ? _c('p', {
            staticClass: "caption ma-0",
            attrs: {
              "align": "left"
            }
          }, [_c('b', [_vm._v("Summary")])]) : _vm._e(), _vm._v(" "), (header.value === 'engagement') ? _c('p', {
            staticClass: "caption ma-0"
          }, [_c('v-chip', {
            staticClass: "ma-1",
            attrs: {
              "color": "primary",
              "small": "",
              "text-color": "white"
            }
          }, [_c('v-icon', {
            staticClass: "mr-0",
            attrs: {
              "small": "",
              "left": ""
            }
          }, [_vm._v("mdi-currency-usd")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")((_vm.summary[header.month] ? _vm.summary[header.month].engagement : 0))))])], 1)], 1) : _vm._e(), _vm._v(" "), (header.value === 'contents') ? _c('p', {
            staticClass: "caption ma-0"
          }, [_c('v-chip', {
            staticClass: "ma-1",
            attrs: {
              "color": "primary",
              "small": "",
              "text-color": "white"
            }
          }, [_c('v-icon', {
            staticClass: "mr-0",
            attrs: {
              "small": "",
              "left": ""
            }
          }, [_vm._v("mdi-currency-usd")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")((_vm.summary[header.month] ? _vm.summary[header.month].contents : 0))))])], 1)], 1) : _vm._e(), _vm._v(" "), (header.value === 'outreach') ? _c('p', {
            staticClass: "caption ma-0"
          }, [_c('v-chip', {
            staticClass: "ma-1",
            attrs: {
              "color": "primary",
              "small": "",
              "text-color": "white"
            }
          }, [_c('v-icon', {
            staticClass: "mr-0",
            attrs: {
              "small": "",
              "left": ""
            }
          }, [_vm._v("mdi-currency-usd")]), _vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")((_vm.summary[header.month] ? _vm.summary[header.month].outreach : 0))) + "\n                  ")], 1)], 1) : _vm._e(), _vm._v(" "), (header.value === 'revenue') ? _c('p', {
            staticClass: "caption ma-0"
          }, [_c('v-chip', {
            staticClass: "ma-1",
            attrs: {
              "color": "primary",
              "small": "",
              "text-color": "white"
            }
          }, [_c('v-icon', {
            staticClass: "mr-0",
            attrs: {
              "small": "",
              "left": ""
            }
          }, [_vm._v("mdi-currency-usd")]), _vm._v(" "), _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('span', _vm._g(_vm._b({}, 'span', attrs, false), on), [_c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")((_vm.summary[header.month] ? (_vm.summary[header.month].revenueCalculation === 'content' ? _vm.summary[header.month].revenueByContents : _vm.summary[header.month].revenue) | _vm.thousandSeprator : 0))))])])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v(_vm._s((_vm.summary[header.month] ? (_vm.summary[header.month].revenueCalculation === 'content' ? 'Revenue by contents' : 'Revenue by engagement') : 'N/A')))])])], 1)], 1) : _vm._e()])
        }), 0), _vm._v(" "), _vm._l((items), function(item, index) {
          return _c('tr', {
            key: index
          }, _vm._l((_vm.headers), function(header, index) {
            return _c('td', {
              key: index,
              staticClass: "caption",
              attrs: {
                "align": "center"
              }
            }, [(header.value === 'campaignName') ? _c('p', {
              staticClass: "caption ma-0",
              attrs: {
                "align": "left"
              }
            }, [_vm._v(_vm._s(item.campaignName))]) : _vm._e(), _vm._v(" "), (header.value === 'engagement') ? _c('p', {
              staticClass: "caption ma-0"
            }, [_c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")((item[header.month] ? item[header.month].engagement : 0))))])]) : _vm._e(), _vm._v(" "), (header.value === 'contents') ? _c('p', {
              staticClass: "caption ma-0"
            }, [_c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")((item[header.month] ? item[header.month].contents : 0))))])]) : _vm._e(), _vm._v(" "), (header.value === 'outreach') ? _c('p', {
              staticClass: "caption ma-0"
            }, [_vm._v(_vm._s(_vm._f("thousandSeprator")((item[header.month] ? item[header.month].outreach : 0))))]) : _vm._e(), _vm._v(" "), (header.value === 'revenue') ? _c('p', {
              staticClass: "caption ma-0"
            }, [_c('v-chip', {
              staticClass: "ma-1",
              attrs: {
                "color": "green",
                "small": "",
                "text-color": "white"
              }
            }, [_c('v-icon', {
              staticClass: "mr-0",
              attrs: {
                "small": "",
                "left": ""
              }
            }, [_vm._v("mdi-currency-usd")]), _vm._v(" "), _c('v-tooltip', {
              attrs: {
                "bottom": ""
              },
              scopedSlots: _vm._u([{
                key: "activator",
                fn: function(ref) {
                  var on = ref.on;
                  var attrs = ref.attrs;

                  return [_c('span', _vm._g(_vm._b({}, 'span', attrs, false), on), [_c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")((item[header.month] ? (item[header.month].revenueCalculation === 'content' ? item[header.month].revenueByContents : item[header.month].revenue) | _vm.thousandSeprator : 0))))])])]
                }
              }], null, true)
            }, [_vm._v(" "), _c('span', [_vm._v(_vm._s((item[header.month] ? (item[header.month].revenueCalculation === 'content' ? 'Revenue by contents' : 'Revenue by engagement') : 'N/A')))])])], 1)], 1) : _vm._e()])
          }), 0)
        })], 2)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50023420"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/CampaignsOverview.vue
// module id = 2121
// module chunks = 0